import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Switch from '../../form/form-switch'

class ModuleChannelLive extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { isProtected } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-channelLive">
            <Switch disabled={disabled}
                    onChange={ e=> {} }
                    checked={isProtected}
                    label='app.modules.protected' />
        </div>;
    }
}

ModuleChannelLive.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,
    isProtected: PropTypes.bool
}

export default ModuleChannelLive;

